// Swaps a photo's real thumbnail in once PromoteImageJob has built it.
//
// ImageUploader serves a placeholder while a photo is still processing and
// encodes the photo's id in that placeholder's query string, so no template has
// to render extra markup for this -- we read the ids straight off the images.
//
// Everything here fails open: on any error we stop polling and leave the
// placeholder, which is exactly the behaviour before this existed (a page
// refresh shows the photo).

const POLL_DELAYS_MS = [1000, 2000, 3000, 5000, 8000]

export default function initPhotoProcessingPoll() {
  Array.from(document.querySelectorAll('img[src*="photo-processing"]')).forEach(
    watchImage
  )
}

function watchImage(img) {
  if (img.dataset.photoPollWatched) return
  img.dataset.photoPollWatched = "1"

  var params
  try {
    params = new URL(img.src, window.location.origin).searchParams
  } catch (e) {
    return
  }

  var id = params.get("photo_id")
  var type = params.get("photo_type")
  if (!id || !type) return

  schedulePoll(img, type, id, 0)
}

function schedulePoll(img, type, id, attempt) {
  if (attempt >= POLL_DELAYS_MS.length) return

  window.setTimeout(function () {
    // The user may have navigated away, or removed the photo from a form.
    if (!img.isConnected) return

    var url =
      "/photo_status/" + encodeURIComponent(type) + "/" + encodeURIComponent(id)

    fetch(url, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (response) {
        return response.ok ? response.json() : null
      })
      .then(function (data) {
        if (!data) return // 404 or not authorized: stop, keep the placeholder
        if (!data.ready) return schedulePoll(img, type, id, attempt + 1)
        applyUrls(img, data)
      })
      .catch(function () {})
  }, POLL_DELAYS_MS[attempt])
}

function applyUrls(img, data) {
  if (data.small_url) img.src = data.small_url

  // Thumbnails are usually wrapped in a link to the large version, which was
  // pointing at the placeholder too.
  var link = img.closest("a")
  if (!link || !data.large_url) return

  var href = link.getAttribute("href") || ""
  if (href.indexOf("photo-processing") !== -1) {
    link.setAttribute("href", data.large_url)
  }
}
